export const NotFoundIcon = ({ className }: { className?: string }) => (
	<svg
		className={className}
		width="80"
		height="80"
		viewBox="0 0 80 80"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<circle cx="40" cy="40" r="38" stroke="#6b7280" strokeWidth="4" fill="#f7f7f9" />
		<line
			x1="28"
			y1="28"
			x2="52"
			y2="52"
			stroke="#6b7280"
			strokeWidth="4"
			strokeLinecap="round"
		/>
		<line
			x1="52"
			y1="28"
			x2="28"
			y2="52"
			stroke="#6b7280"
			strokeWidth="4"
			strokeLinecap="round"
		/>
	</svg>
);
